import { render, staticRenderFns } from "./filtered-quotes.vue?vue&type=template&id=07141c0f"
import script from "./filtered-quotes.vue?vue&type=script&lang=js"
export * from "./filtered-quotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports